/** 고객 요청 추가 전달의 발송이력 유형 코드 — BE WorklogSendHist.SEND_TYPE_CUST_REQ_SHARED·공통코드 ZEU_WORKLOG_SEND_TYPE 값과 동일 (알림 유형 WORKLOG_CUSTREQ_SHARED 와 다른 값) */
export const CUST_REQ_SHARED_SEND_TYPE = 'CUST_REQ_SHARED'
export const CUST_REQ_SHARED_LABEL = '고객 요청 추가 전달'
